import React from "react";
import { Link } from "react-router-dom";
import { getPlayer, getPlayerToken } from "../lib/api";
import { User } from "lucide-react";

// Bouton « Mon compte » → mène à l'espace client /compte (dashboard des bons, type Pongo).
export default function AccountButton() {
  const player = getPlayer();
  const loggedIn = !!getPlayerToken() && !!player;
  return (
    <Link to="/compte" data-testid="account-button"
      className="flex items-center gap-1.5 text-ink text-xs font-bold bg-white px-3 py-1.5 rounded-full shadow-[0_3px_0_rgba(0,0,0,0.15)] hover:translate-y-0.5">
      <User size={14} />
      {loggedIn ? (player.first_name || "Mon compte") : "Mon compte"}
    </Link>
  );
}
